import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@awesome.me/kit-70c1f0055f/icons/classic/light";

export type DestructiveTrashIconButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  "aria-label"?: string;
  "data-testid"?: string;
  className?: string;
};

/**
 * Icon-only delete control for headers and toolbars.
 * One visual system across pods, documents, portfolio, product, etc. — do not use
 * `Button plain` here (different height, radius, and neutral hover).
 */
export function DestructiveTrashIconButton({
  onClick,
  disabled,
  title,
  "aria-label": ariaLabel,
  "data-testid": dataTestId,
  className,
}: DestructiveTrashIconButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel ?? title ?? "Delete"}
      data-testid={dataTestId}
      className={clsx(
        // Match adjacent `Button` (h-9, rounded-xl) so headers align with Save / primary actions.
        "group inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl transition-colors",
        disabled
          ? "cursor-not-allowed opacity-40"
          : "cursor-pointer hover:bg-red-100 dark:hover:bg-red-900/30",
        className,
      )}
    >
      <FontAwesomeIcon
        icon={faTrashAlt}
        className={clsx(
          "h-4 w-4 transition-colors",
          disabled
            ? "text-gray-400 dark:text-gray-500"
            : "text-red-500 group-hover:text-red-700 dark:text-red-400 dark:group-hover:text-red-300",
        )}
      />
    </button>
  );
}
